import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        // Show tooltip 2 seconds after mount to draw gentle attention
        const timer = setTimeout(() => {
            setShowTooltip(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const whatsappUrl = "https://wa.me/919823162163?text=Hello!%20I%20would%20like%20to%20get%20more%20information%20about%20Choundeshwari%20Credit%20Society's%20services.";

    return (
        <div className="fixed bottom-6 right-6 z-50 flex items-center flex-row-reverse gap-3">
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-2xl hover:bg-[#20ba59] hover:scale-110 transition-all duration-300 group relative flex-shrink-0"
                aria-label="Contact us on WhatsApp"
            >
                {/* Continuous Pulse Animation Ring */}
                <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping"></span>
                <FaWhatsapp className="text-3xl relative z-10" />
            </a>

            {showTooltip && (
                <div className="bg-white text-gray-800 text-xs font-semibold px-3 py-2 rounded-lg shadow-lg border border-gray-100 relative animate-bounce flex items-center gap-1.5 whitespace-nowrap">
                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                    Chat with us!
                    <button 
                        onClick={() => setShowTooltip(false)} 
                        className="ml-1 text-gray-400 hover:text-gray-600 focus:outline-none font-bold text-sm"
                        aria-label="Close tooltip"
                    >
                        &times;
                    </button>
                    {/* Tooltip triangle pointing right towards the icon */}
                    <div className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white border-r border-t border-gray-100 rotate-45"></div>
                </div>
            )}
        </div>
    );
};

export default WhatsAppButton;
